module.exports = __webpack_public_path__ + "static/media/floor-panel.d8318d50.png";